var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', _vm._g(_vm._b({ directives: [{ name: "loading", rawName: "v-loading", value: _vm.editorLoading, expression: "editorLoading" }], ref: "editor", staticClass: "main-editor", style: _vm.formItemStyle }, 'div', _vm.innerConfig.params, false), _vm.$listeners));
};
var staticRenderFns = [];

export { render, staticRenderFns };